/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @internal Const @name MixinBase                                                              **/
/**************************************************************************************************/
const MixinBase = defineComponent(
{
	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			ToasterOptions:
			{
				append: false,
				autoHideDelay: 4000,
				toaster: 'b-toaster-bottom-right',
				variant: 'default'
			}
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		ShowToast(title: string, message: string, variant = 'default') : void
		{
			this.$bvToast.toast(message, {
				title, variant,
				autoHideDelay: this.ToasterOptions.autoHideDelay,
				appendToast: this.ToasterOptions.append,
				toaster: this.ToasterOptions.toaster
			})
		}
	}
})

/**************************************************************************************************/
/** @export Component @name MixinBase                                                            **/
/**************************************************************************************************/
export default MixinBase